import { render, staticRenderFns } from "./cockfight-video.vue?vue&type=template&id=7d0dc4d7"
import script from "./cockfight-video.vue?vue&type=script&lang=js"
export * from "./cockfight-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0dc4d7')) {
      api.createRecord('7d0dc4d7', component.options)
    } else {
      api.reload('7d0dc4d7', component.options)
    }
    module.hot.accept("./cockfight-video.vue?vue&type=template&id=7d0dc4d7", function () {
      api.rerender('7d0dc4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/cockfight-video.vue"
export default component.exports